import { Button, CardActionArea } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { getStoresAction } from "../../../../store/store/actions";
import {
  getSessionData,
  removeSessionData,
} from "../../base/helper/baseHelper";
import { info } from "../../../../store/notification/actions";
import UserProfile from "../../base/views/UserProfile";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import TimelineIcon from "@material-ui/icons/Timeline";

const MyApps = (props) => {
  const useStyles = makeStyles((theme) => ({
    heroContent: {
      padding: theme.spacing(8, 0, 6),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderBottomRightRadius: "1rem",
      borderBottomLeftRadius: "1rem",
      "&:hover": {
        width: "103%",
        height: "103%",
        backgroundColor: "none",
      },
    },
    cardContent: {
      flexGrow: 1,
    },
    appBar: {
      // backgroundColor: "cornflowerblue",
      backgroundColor: "white",
      backdropFilter: "blur(6px)",
    },
    title: {
      flexGrow: 1,
      color: "rgba(0, 0, 0, 0.7);",
    },
    horizontalList: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "reverse",
    },
    dot: {
      height: "10px",
      width: "20px",
      borderRadius: "30%",
      display: "inline-block",
    },
    margin: {
      margin: theme.spacing(1),
    },
  }));
  const history = useHistory();
  const { stores, getStores, deleteStore, editStore } = props;
  const [isglobal, setGlobal] = useState("0");
  const [userId, setUserId] = useState("");
  const [isAdmin, setAdmin] = useState("0");
  const [apps, setApps] = useState([
    {
      id: 1,
      app_name: "AIMS Suite",
      app_header: "AS",
      app_description: "Access all the AIMS modules",
      app_url: "/home",
    },
    {
      id: 2,
      app_name: "Master Data Management",
      app_header: "MDM",
      app_description: "Manage all the products at one place",
      app_url: "/masterProductManagement",
    },
    {
      id: 3,
      app_name: "Physical Inventory",
      app_header: "PI",
      app_description: "Captures inventories and generates report",
      app_url: "/apps",
    },
  ]);

  useEffect(() => {
    removeSessionData({ key: "store" });
    removeSessionData({ key: "userModules" });
  });

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    setGlobal(getSessionData({ key: "isglobalUser" }));
    setAdmin(getSessionData({ key: "isAdmin" }));
    if (isAdmin === "1") {
      history.push({ pathname: "/masterProducts" });
    } else if (userId) {
      info("Loading Pharmacy Dashboard...");
      getStores(userId);
    }
  }, [userId, getStores, isAdmin, history]);

  const classes = useStyles();
  return (
    <div>
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar>
          <Typography
            component="h1"
            variant="h5"
            noWrap
            className={classes.title}
          >
            <Button
              onClick={() => history.push("/home")}
              startIcon={<TimelineIcon />}
            >
              AIMS
            </Button>
          </Typography>
          {/* {stores?.some((store) => store.adminflag === "1") && (
              <>
                <Tooltip title="Admin Center">
                  <IconButton size="medium" onClick={()=>history.push("/activeUsers")}>
                    <SupervisorAccountIcon />
                  </IconButton>
                </Tooltip>
                <Typography>{"\u00A0 \u00A0"}</Typography>
                
              </>
            )} */}
          <UserProfile />
        </Toolbar>
      </AppBar>
      <main>
        <CssBaseline />
        <div className={classes.heroContent}>
          <Typography
            component="h1"
            variant="h2"
            align="center"
            color="textPrimary"
            gutterBottom
          >
            {/* Pharmacy Dashboard */}
            My Apps
          </Typography>
          <Container
            className={classes.cardGrid}
            maxWidth="lg"
            style={{ height: "60vh" }}
          >
            <Grid
              container
              spacing={4}
              justifyContent="space-evenly"
              style={{ height: "100%" }}
            >
              {apps.map((app, i) => {
                return (
                  <Grid
                    item
                    key={i}
                    xs={12}
                    sm={12}
                    md={3}
                    style={{ height: "100%" }}
                  >
                    <Card
                      className={classes.card}
                      onClick={() => {
                        history.push({ pathname: app.app_url });
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {/* <CardHeader
                        style={{backgroundColor: "rgba(22, 177, 255, 0.5)"}}
                        avatar={
                          <LocalPharmacyIcon
                            className="text-center"
                            fontSize="large"
                          />
                        }
                        title={app.app_header.toUpperCase()}
                      /> */}

                      <CardActionArea style={{ height: "85%" }}>
                        <CardContent
                          className={classes.cardContent}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: "100%",
                          }}
                        >
                          <LocalPharmacyIcon
                            className="text-center"
                            fontSize="large"
                          />
                          <Typography variant="h5" align="center">
                            {app.app_name}
                          </Typography>

                          <Typography variant="h6" align="center">
                            {app.app_description}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
};

const mapStateToProps = (state) => {
  return { stores: state.store };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (userId) => dispatch(getStoresAction(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyApps);
